export default __webpack_public_path__ + "static/media/no-results.c8c4b660.svg";